<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
      <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
        <span *ngIf="status"><i class="fas fa-angle-right"></i></span>

        <span *ngIf="!status"><i class="fas fa-angle-left"></i></span>
      </div>
      <div class="sidebar-header">
          <h3>{{'NavMenu.NewsInfo'|translate}}</h3>
      </div>

      <ul class="list-unstyled components">

        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="newsroom">{{'NavMenu.Newsroom'|translate}}</a>
        </li>
        <li>
          <a  [innerHTML]="'Newsletters'|translate" routerLinkActive="active-tab" (click)="status=!status" routerLink="newsletters"></a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="enotification">{{'Homeowner Alert Service'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="events">{{'NavMenu.Events'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="webinars-presentations">{{'NavMenu.Webinars'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="annualroll">{{'NavMenu.AnnualReport'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="assessmentroll">{{'NavMenu.AssessmentRoll'|translate}}</a>
        </li>
        <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="awards">{{'NavMenu.Awards'|translate}}</a>
        </li>
        <!-- <li>
          <a routerLinkActive="active-tab" (click)="status=!status" routerLink="publicrecord">{{'PublicRecords.SearchTitle'|translate}}</a>
        </li> -->


      </ul>

  </nav>
  <div id="content">

            <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
                <i class="fas fa-align-left"></i>
                <span>Toggle Sidebar</span>
            </button> -->
            <router-outlet></router-outlet>
</div>


</div>
